import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpStoreProjectBudget, HttpStoreProjectBudgetOptions} from '../http/budget.http'
import {ProjectBudgets} from '../types'

export const useStoreProjectBudget = (
    options?: UseMutationOptions<ProjectBudgets, unknown, HttpStoreProjectBudgetOptions['payload']>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (payload: HttpStoreProjectBudgetOptions['payload']) => httpStoreProjectBudget({payload}),
        ...options,
        onSuccess: (data, variables, context) => {
            queryClient.setQueryData([QUERY_KEYS.PROJECT_BUDGETS], (oldData: ProjectBudgets[]) => [data, ...oldData])
            options?.onSuccess?.(data, variables, context)
        }
    })
}
